module.exports = __webpack_public_path__ + "static/media/linkedin.7887ab23.svg";